const Aggression = require("../../entities/Aggression")
const {Age}  = require("../Constants");
const AggessionNames = require("../Names/AggressionNames");

class Kidnap extends Aggression {
    constructor() {
        super(
            Age.Age1,
            AggessionNames.Kidnap,
            1,
            "Take one civil card from your rival's hand, obeying all the card taking limitations. If you play that card this turn, score 3 culture.",
            {
                //effect
            }
        )
    }
}

module.exports = Kidnap;